/* eslint react/forbid-prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint no-unneeded-ternary: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Panel, Button } from "react-bootstrap";
import Select from "react-select";
import Client from "../../../../Client";

class AllocatedVehicle extends Component {
  state = {
    vehicle: {},
    fetched: false
  };

  componentDidMount() {
    const vehicleId = this.props.vehicleId;
    if (vehicleId) {
      Client.getVehicle(vehicleId).then(vehicle =>
        this.setState({ vehicle, fetched: true })
      );
    }
  }

  removeAllocation = () => {
    this.props.removeAllocation();
  };

  render() {
    const { vehicle, fetched } = this.state;
    if (this.props.vehicleId && fetched) {
      return (
        <Panel>
          <Panel.Body>
            Runsheet currently allocated to: {vehicle.name}{" "}
            <Button bsStyle="danger" onClick={this.removeAllocation}>
              Remove Allocation
            </Button>
          </Panel.Body>
        </Panel>
      );
    }

    return "";
  }
}
AllocatedVehicle.propTypes = {
  vehicleId: PropTypes.number,
  removeAllocation: PropTypes.func.isRequired
};
AllocatedVehicle.defaultProps = {
  vehicleId: 0
};

class VehicleTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicleId: props.initialVehicleId,
      allocating: false
    };
  }

  handleChange = selectedOption => {
    if (selectedOption) {
      const vehicleId = parseInt(selectedOption.value, 10);
      this.setState({ vehicleId });
    } else {
      this.setState({ vehicleId: "" });
    }
  };

  handleSelect = () => {
    this.setState({ allocating: true });
    const vehicle = this.props.vehicles.find(
      v => v.id === this.state.vehicleId
    );
    this.props.handleAssignVehicle(vehicle);
  };

  handleCancel = () => {
    this.props.closeAllocateRunsheet();
  };

  generateSelectOptions = collection =>
    collection
      .map(item => ({
        label: item.name,
        value: `${item.id}`
      }))
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

  render() {
    const fleetOptions = this.generateSelectOptions(this.props.fleets);
    const vehicleOptions = this.generateSelectOptions(this.props.vehicles);
    const labelContainer = {
      display: "inline-block",
      width: 100,
      verticalAlign: "top"
    };
    const labelStyle = { display: "inline-block", marginTop: 5 };
    const selectStyle = { display: "inline-block", width: 300 };

    return (
      <div>
        <AllocatedVehicle
          vehicleId={this.state.vehicleId}
          removeAllocation={this.props.removeAllocation}
        />

        <div>
          <div style={labelContainer}>
            <span style={labelStyle}>Fleet</span>
          </div>
          <div style={selectStyle}>
            <Select
              options={fleetOptions}
              value={this.props.fleetId}
              onChange={this.props.handleFleetChange}
            />
          </div>
        </div>

        <div style={labelContainer}>
          <span style={labelStyle}>Vehicle</span>
        </div>
        <div style={selectStyle}>
          {this.props.fleetId ? (
            <Select
              value={this.state.vehicleId}
              options={vehicleOptions}
              onChange={this.handleChange}
            />
          ) : (
            <Select
              disabled
              value={this.state.vehicleId}
              options={vehicleOptions}
              onChange={this.handleChange}
            />
          )}
        </div>

        <div style={{ marginTop: 15 }}>
          <Button onClick={this.handleCancel}>Cancel</Button>
          {this.state.allocating ? (
            <Button bsStyle="primary" className="pull-right" disabled>
              Allocating...
            </Button>
          ) : (
            <Button
              bsStyle="primary"
              className="pull-right"
              disabled={this.state.vehicleId === 0 ? true : false}
              onClick={this.handleSelect}
            >
              Allocate
            </Button>
          )}
        </div>
      </div>
    );
  }
}
VehicleTable.propTypes = {
  fleetId: PropTypes.string.isRequired,
  fleets: PropTypes.array.isRequired,
  vehicles: PropTypes.array.isRequired,
  initialVehicleId: PropTypes.number,
  handleFleetChange: PropTypes.func.isRequired,
  handleAssignVehicle: PropTypes.func.isRequired,
  closeAllocateRunsheet: PropTypes.func.isRequired,
  removeAllocation: PropTypes.func.isRequired
};
VehicleTable.defaultProps = {
  initialVehicleId: 0
};

export default VehicleTable;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/actions/VehicleTable.js